<template>
  <div></div>
</template>

<script>
import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'OAuth2',
  mounted() {
    this.$store.dispatch('toggleLoading', true, { root: true });
    API.get(ENDPOINTS.GET_OAUTH_AUTHORISE, {
      params: {
        ...this.$route.query,
      },
    })
      .then((res) => {
        window.location.replace(res.data.data.redirect);
        // this.$store.dispatch('toggleLoading', false, { root: true });
      })
      .catch(err => console.log(err));
  },
};
</script>
